import { Injectable } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { parse } from 'path';
import { ApiService } from './api.service';
import { SharedService } from './shared.service';
@Injectable()

export class CommonServices {

    constructor(
        private fb: FormBuilder,
        private share: SharedService,
        private api: ApiService
    ) { }
    toRad(Value) {
        return Value * Math.PI / 180;
    }
    calcCrow(lat1, lon1, lat2, lon2) {
        // let R = 6371; // km
        let R = 6371e3;  // meter
        let dLat: any = this.toRad(lat2 - lat1);
        let dLon: any = this.toRad(lon2 - lon1);
        var lat1: any = this.toRad(lat1);
        var lat2: any = this.toRad(lat2);

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d;
    }
    filterLatLng(value: any, start?, end?) {
        return new Promise((res, rej) => {
            try {
                let latLng = [];
                let data: any = [];
                if (start && end) {
                    data = [];
                    value.map((item) => {
                        let gpsTs = String(item.gpsts).length > 10 ? item.gpsts : item.gpsts * 1000;
                        if (gpsTs > start && gpsTs < end) {
                            data.push(item);
                        }
                    });
                } else {
                    data = [...value];
                }
                let obj: any = data.sort(function (x, y) {
                    return x.gpsts - y.gpsts;
                });

                for (let i = 0; i < obj.length; i++) {
                    let previous: any = 0;
                    let item = obj[i];
                    if (Object.keys(item).length > 0 && item['lat'] && item['lng']) {
                        if (i > 0) {
                            let previous = latLng.length - 1;
                            if ((obj[i].lat != latLng[previous][0]) && (obj[i].lng != latLng[previous][1])) {
                                let getDist: any = this.calcCrow(item['lat'], item['lng'], latLng[previous][0], latLng[previous][1]).toFixed(2);
                                // console.log('getDist',getDist)
                                if ((+getDist) > 200) {
                                    let speed = +item['spd'];
                                    if (speed < 0) {
                                        speed = 0;
                                        item['spd'] = 0;
                                    }
                                    let color = parseInt(item['spd']) < 5 ? '#DC143C' : (parseInt(item['spd']) > 60 ? '#2E77E8' : '#2EA737');
                                    let tempObj = {
                                        //    title: `Speed : ${speed} , Date : ${  this.timestampToDate(item['gpsts'],'DMY H:M:S') } `,
                                        plotMarker: `<div class="mumb_marker_circle" style="background: ${color}; width: 10px;"></div>`,
                                    }
                                    latLng.push([+(item.lat), +(item.lng), tempObj, speed, item['gpsts'].length > 10 ? item['gpsts'] : item['gpsts'] * 1000]);
                                }
                                // let floatLat = parseFloat(item.lat);
                                // let floatLng = parseFloat(item.lng);
                                // if(!Number.isNaN(floatLat) && !Number.isNaN(floatLng)){
                                //     latLng.push([Number(floatLat.toFixed(5)), Number(floatLng.toFixed(5))]);
                                // }  
                            }
                        }
                        else {
                            let speed = +item['spd'];
                            if (speed < 0) {
                                speed = 0;
                                item['spd'] = 0;
                            }
                            let color = parseInt(item['spd']) < 5 ? '#DC143C' : (parseInt(item['spd']) > 60 ? '#2E77E8' : '#2EA737');
                            let tempObj = {
                                // title: `Speed : ${speed} , Date : ${  this.timestampToDate(item['gpsts'],'DMY H:M:S') } `,
                                plotMarker: `<div class="mumb_marker_circle" style="background: ${color}; width: 10px;"></div>`,
                            }
                            latLng.push([+(item.lat), +(item.lng), tempObj, speed, item['gpsts'].length > 10 ? item['gpsts'] : item['gpsts'] * 1000]);
                            // let floatLat = parseFloat(item.lat);
                            // let floatLng = parseFloat(item.lng);
                            // if(!Number.isNaN(floatLat) && !Number.isNaN(floatLng)){
                            //     latLng.push([Number(floatLat.toFixed(5)), Number(floatLng.toFixed(5))]);
                            // }  
                        }
                    }
                }
                res(latLng);
            } catch (error) {
                res([]);
            }
        });
    }
    currentDayTrackingData(obj) {
        //getTrackingData
        return new Promise(async (resolve, reject) => {

            let trackingData = [];

            let res = await this.api.getTrackingData(obj).catch((e) => { console.log("Get tracking data"); });
            if (res && res['status'] == 'success') {
                if (res['data'].length <= 0) reject({ 'err': "Getting empty data" });
                else {
                    if (res['data'].length > 0) trackingData = [...trackingData, ...res['data']];
                }
            } else reject({ "err": "Failure" });

            //   while (ping) {
            //     obj['page'] = i + 1;
            //     obj['limit'] = 'all';
            //     i++;
            //     let res = await this.api.getTrackingData(obj).catch((e) => { console.log("Get tracking data"); });
            //     if (res && res['status'] == 'success') {
            //       if (res['data'].length <= 0) ping = 0;
            //       else {
            //         if (res['data'].length > 0) trackingData = [...trackingData, ...res['data']];
            //       }
            //     }else ping = 0;
            //   }

            resolve(trackingData);

        })
    }

    currentDayRouteData(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                let routes: any = await this.getAPILoopData('transportMangerRouteList', obj).catch((err) => { throw (err) })

                if (routes && routes.length > 0) {
                    for (let r = 0; r < routes.length; r++) {
                        let route = routes[r];
                        let apiMethod = 'listRoutePickupPoint';
                        if (route['routeType'] == 'openBooking') apiMethod = 'transportManagerOpenBookingRouteListPP';

                        await this.api[apiMethod]({ routeID: route['routeID'] }).then((res: any) => {
                            if (res.status == 'success' && res.data && res.data.length > 0) {
                                let pickuppoints = {};
                                res.data.map((item) => {
                                    if (pickuppoints[item['vehRegNo']] == undefined) pickuppoints[item['vehRegNo']] = [];
                                    pickuppoints[item['vehRegNo']] = item;
                                })
                                route['pickupPoints'] = pickuppoints;
                                route['vehicle'] = Object.keys(pickuppoints);
                            }
                        });
                        routes[r] = route;
                    }
                }

                resolve(routes);
            }
            catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }

    vehicleToObject(vehicleList: any, selectedVehicle: any) {
        return new Promise(async (res, rej) => {
            try {
                let processVehicle = {};
                if (selectedVehicle == 'ALL') {
                    const vehList = await this.getObjKeyValue(vehicleList, 'vehRegNo', 'vehRegNo');
                    processVehicle = vehList;
                } else {
                    const vehicle = vehicleList.filter((item) => {

                        if (item.vehRegNo == selectedVehicle) { return item; }
                    });
                    processVehicle = await this.getObjKeyValue(vehicle, 'vehRegNo', 'vehRegNo');

                }
                res(processVehicle);
            } catch (error) {
                console.log('vehicleToObject -- Error', error);
            }
        });
    }

    pad(num) {
        return num > 9 ? num : '0' + num;
    }
    numberPadEnd(num) {
        return num.length <= 1 ? num + '0' : num;
    }
    subString(str, start, end) {
        return str.substring(start, end);
    }
    strReplace(string, search, replace) {
        return string.split(search).join(replace);
    }
    timestampToDate(timestamp, type = 'YMD', splited = '/') {
        const strl = (timestamp + '').length;
        const tms = strl > 10 ? timestamp : timestamp * 1000;
        const d = new Date(tms);
        let temp;
        // console.log('timestamp',timestamp)
        const h = this.pad(d.getHours());
        const m = this.pad(d.getMinutes());
        const s = this.pad(d.getSeconds());
        if (type == 'YMD') {
            temp =
                d.getFullYear() +
                splited +
                this.pad(d.getMonth() + 1) +
                splited +
                this.pad(d.getDate());
        } else if (type == 'MDY') {
            temp =
                this.pad(d.getMonth() + 1) +
                splited +
                this.pad(d.getDate()) +
                splited +
                d.getFullYear();
        } else if (type == 'DMY') {
            temp =
                this.pad(d.getDate()) +
                splited +
                this.pad(d.getMonth() + 1) +
                splited +
                d.getFullYear();
        } else if (type == 'YMD H:M:S') {
            temp =
                this.pad(d.getDate()) +
                splited +
                this.pad(d.getMonth() + 1) +
                splited +
                d.getFullYear() +
                ' ' +
                h +
                ':' +
                m +
                ':' +
                s;
        } else if (type == 'DMY H:M:S') {
            temp =
                this.pad(d.getDate()) +
                splited +
                this.pad(d.getMonth() + 1) +
                splited +
                d.getFullYear() +
                ' ' +
                h +
                ':' +
                m +
                ':' +
                s;
        } else if (type == 'DMY H:M A') {
            let hour = h;
            const ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12;
            hour = hour ? hour : 12;
            hour = this.pad(hour);
            temp =
                this.pad(d.getDate()) +
                splited +
                this.pad(d.getMonth() + 1) +
                splited +
                d.getFullYear() +
                ' ' +
                hour +
                ':' +
                m +
                ' ' +
                ampm;
        } else if (type == 'DMY_H_M_S') {
            temp =
                this.pad(d.getDate()) +
                '_' +
                this.pad(d.getMonth() + 1) +
                '_' +
                d.getFullYear() +
                '_' +
                h +
                '_' +
                m +
                '_' +
                s;
        } else if (type == 'H:M:S') {
            temp = h + ':' + m + ':' + s;
        }

        return temp;
    }

    public timeChange: any = '';
    convertTime(clk) {
        this.timeChange = new Date(clk).toLocaleTimeString();

        let final24Hrs = '';
        const [time, modifier] = this.timeChange.split(" ");
        let [hours, minutes] = time.split(":");
        if (hours === "12") {
            hours = "00";
        }
        if (modifier === "PM") {
            hours = parseInt(hours, 10) + 12;
        }
        final24Hrs = `${hours}:${minutes}`
        return final24Hrs;
    }

    chunkArray(data, chunksize) {
        return new Promise(function (res, rej) {
            const chunks = [];
            if (data.length > chunksize) {
                data.map(function (item) {
                    if (!chunks.length || chunks[chunks.length - 1].length == chunksize) {
                        chunks.push([]);
                    }

                    chunks[chunks.length - 1].push(item);
                });
            } else {
                chunks.push(data);
            }

            res(chunks);
        });
    }

    chunkObject(object, size) {
        return new Promise(function (res, rej) {
            try {
                let temp = {};
                const chunks = [];
                let chunkSize = size;
                const amount = chunkSize;

                for (let i = 0; i < Object.keys(object).length; i++) {
                    if (i == chunkSize) {
                        chunks.push(temp);
                        chunkSize += amount;
                        temp = {};
                    }

                    temp[Object.keys(object)[i]] = object[Object.keys(object)[i]];

                    if (i == Object.keys(object).length - 1) {
                        chunks.push(temp);
                    }
                }
                res(chunks);
            } catch (error) {
                console.log('object chunk ', error);
            }
        });
    }
    sleep(num) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, Number(num));
        });
    }
    getObjSingleValue(obj, key) {
        return new Promise((res, rej) => {
            const temp = [];
            for (const i of obj) {
                try {
                    temp.push(i[key]);
                } catch (err) {
                    console.log(err);
                }
            }
            res(temp);
        });
    }
    getObjKeyValue(obj, key, value) {
        return new Promise((res, rej) => {
            const temp = {};
            for (const i of obj) {
                try {
                    if (temp[i[key]] == undefined) { temp[i[key]] = {}; }
                    temp[i[key]] = i[value];
                } catch (err) {
                    console.log(err);
                }
                // temp.push(i[key]);
            }
            res(temp);
        });
    }
    filterObj(obj, array) {
        return new Promise((res, rej) => {
            try {
                const data = obj.filter((item) => {
                    const chk = array.indexOf(item.vehRegNo);
                    if (chk == -1) { return item; }
                });
                res(data);
            } catch (e) {
                rej();
            }
        });
    }

    formToDateValidation(from: string, to: string, vehType: string) {
        return (group: FormGroup): { [key: string]: any } => {
            const veh = group.controls[vehType].value;
            const f = new Date(group.controls[from].value).getTime();
            const t = new Date(group.controls[to].value).getTime();
            let retValue = {};
            const datesAreOnSameDay = (first, second) =>
                first.getFullYear() === second.getFullYear() &&
                first.getMonth() === second.getMonth() &&
                first.getDate() === second.getDate();
            // console.log(veh == 'ALL' && group.controls[from].value && group.controls[to].value)
            if (f > t) {
                retValue = {
                    dates: 'Start Date should be less than End Date'
                };
            } else if ((veh.includes('ALL') || (Array.isArray(veh) && veh.length > 1)) && group.controls[from].value && group.controls[to].value) {
                let valid = datesAreOnSameDay(new Date(group.controls[from].value), new Date(group.controls[to].value));

                if (!valid) {
                    retValue = {
                        dates: 'Single day only allowed to download'
                    };
                }
            }
            return retValue;
        };

    }

    // formToDateAllVehicleValidation(vehType:string,from: string, to: string) {
    //     return (group: FormGroup): { [key: string]: any } => {
    //         const veh = group.controls[vehType].value;
    //         const f = new Date(group.controls[from].value).getTime();
    //         const t = new Date(group.controls[to].value).getTime();

    //         console.log('Veh ', veh, ' F ',f ,' T ',t);
    //         let retValue = {};
    //         // console.log('f ', f, ' t ',t);
    //         // if (f > t) {
    //         //     retValue = {
    //         //         dates: 'Date from should be less than Date to'
    //         //     };
    //         // }
    //         return retValue;
    //     };

    // }

    ts2str(currentts, startTs) {
        // 3660 -> 00:00 - 01:00 diff btn time ts in hour
        let h = Math.floor((currentts - startTs) / 3660),
            m = Math.floor((currentts - (startTs + (3600 * h))) / 60),
            s = (currentts - (startTs + (3600 * h))) % 60;
        if (m >= 60) { h++; m = m - 60; }
        return this.pad(h) + ':' + this.pad(m) + ':' + this.pad(s);
    }
    timeDiff(startTime, endTime) {
        const milliseconds = (endTime.toString().length > 10 ? endTime : endTime * 1000) -
            (startTime.toString().length > 10 ? startTime : startTime * 1000);
        let day: any, hour: any, minute: any, seconds: any;
        seconds = Math.floor(milliseconds / 1000);
        minute = Math.floor(seconds / 60);
        seconds = seconds % 60;
        hour = Math.floor(minute / 60);
        minute = minute % 60;
        // day = Math.floor(hour / 24);
        // hour = hour % 24;
        const minut: any = ('' + minute).length == 1 ? '0' + minute : minute;
        return {
            timeString: hour + ' hour ' + minute + ' minute ' + seconds + ' seconds',
            hhMM: parseFloat(hour + '.' + minut),
            HHMM: (('' + hour).length == 1 ? '0' + hour : hour) + ' : ' + (('' + minute).length == 1 ? '0' + minute : minute) + ' : ' + (('' + seconds).length == 1 ? '0' + seconds : seconds),
            hh: hour,
            mm: ('' + minute).length == 1 ? '0' + minute : minute,
            minute: minute,
            seconds: seconds,
        };
    }
    public timerOn: any = true;
    // timer(remaining,id) {
    //     let m: any = Math.floor(remaining / 60);
    //     let s: any = remaining % 60;

    //     m = m < 10 ? '0' + m : m;
    //     s = s < 10 ? '0' + s : s;
    //     // document.getElementById(id).innerHTML = m + ':' + s;
    //     this.share._subject.next({type:'timer', data : m + ':' + s,id:id});
    //     remaining -= 1;
    //     let p= this;
    //     if (remaining >= 0 && this.timerOn) {
    //         setTimeout(function () {
    //            p.timer(remaining,id);
    //         }, 1000);
    //         return;
    //     }

    //     if (!this.timerOn) {
    //         // Do validate stuff here
    //         return;
    //     }

    //     // Do timeout stuff here
    //     this.share._subject.next({type:'timer', data : false,id:id});
    //     // return false;
    //     // alert('Timeout for otp');
    // }

    convertTitleCase(title: string) {
        let titleArray = title.toLowerCase().split(' ');
        for (var i = 0; i < titleArray.length; i++) {
            titleArray[i] = titleArray[i].charAt(0).toUpperCase() + titleArray[i].slice(1);
        }
        return titleArray.join(' ');
    }

    strTruncate(value: string, max: number, start: number = 0) {
        let returnValue = value.charAt(0).toUpperCase() + value.slice(1);
        if (max && value.length > max) {
            returnValue = (String(returnValue).slice(start, max)).concat('...');
        }
        return returnValue
    }

    getDecimalTime(time) {
        var hoursMinutes = String(time).split(/[.:]/);
        var hours = parseInt(hoursMinutes[0], 10);
        var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
        return hours + minutes / 100;
    }
    getTimeString(timeString, sepateBy: string = ':', decimal: boolean = false) {     // time '10:20'
        let splitTime = String(timeString).split(sepateBy);            // 10, 20
        splitTime[1] = splitTime[1] == undefined ? '0' : splitTime[1];
        let hour = this.pad(Number(splitTime[0]));
        let minute = decimal ? this.numberPadEnd(splitTime[1]) : this.pad(Number(splitTime[1]));
        let timeformat = `${hour}:${minute}`;
        return timeformat;
    }

    getAPILoopData(apiMethod, params) {
        //getTrackingData
        return new Promise(async (resolve, reject) => {

            let trackingData = [], ping = 1, i = 0;
            while (ping) {
                params['page'] = i + 1;
                i++;
                let res = await this.api[apiMethod](params).catch((e) => { console.log(e); ping = 0; });
                if (res && res['status'] == 'success') {
                    if (res['data'].length <= 0) ping = 0;
                    else {
                        if (res['data'].length > 0) trackingData = [...trackingData, ...res['data']];
                    }
                } else ping = 0;
            }
            resolve(trackingData);
        })
    }

    strSimilarity(s1, s2) {
        return new Promise((resolve, reject) => {
            try {
                var longer = s1;
                var shorter = s2;
                if (s1.length < s2.length) {
                    longer = s2;
                    shorter = s1;
                }
                var longerLength = longer.length;
                if (longerLength == 0) {
                    resolve(1.0);
                }
                resolve((longerLength - this.findStrDistance(longer, shorter)) / parseFloat(longerLength) * 100);
            } catch (err) {
                console.log(err);
                reject(err);
            }
        })
    }

    findStrDistance(s1, s2) {
        s1 = s1.toLowerCase();
        s2 = s2.toLowerCase();

        var costs = new Array();
        for (var i = 0; i <= s1.length; i++) {
            var lastValue = i;
            for (var j = 0; j <= s2.length; j++) {
                if (i == 0) costs[j] = j;
                else {
                    if (j > 0) {
                        var newValue = costs[j - 1];
                        if (s1.charAt(i - 1) != s2.charAt(j - 1))
                            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                        costs[j - 1] = lastValue;
                        lastValue = newValue;
                    }
                }
            }
            if (i > 0) costs[s2.length] = lastValue;
        }
        return costs[s2.length];
    }
    sortShifts(arr) {
        for (let i = 0; i < arr.length; i++) {
            arr[i] = Number(arr[i].replace(':', '.'));
        }
        let shifts = arr.sort((a, b) => { return a - b; });
        for (let j = 0; j < shifts.length; j++) {
            shifts[j] = String(shifts[j]);
            if (shifts[j].includes('.')) {
                let x = shifts[j].split('.');
                if (x[0].length == 1) x[0] = '0' + x[0];
                if (x[1].length == 1) x[1] = x[1] + '0';
                shifts[j] = x.join(':');

            } else {
                if (shifts[j].length == 1) shifts[j] = '0' + shifts[j] + ':' + '00';
                else shifts[j] = shifts[j] + ':' + '00';
            }
        }
        return shifts;
    }

    sortGroupByShiftTime(data, key) {
        return new Promise((res, rej) => {
            try {
                let sortedData = data.sort((a, b) => { return a[key] - b[key]; });
                res(sortedData);
            } catch (err) {
                console.log(err);
                rej([])
            }
        })
    }
    

    convertDateString(dateString) {
        const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
        if (!dateFormatRegex.test(dateString)) {
            return dateString;
        } else {
            const date = new Date(dateString);

            // Extract day, month, and year
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
            const year = date.getFullYear();

            // Return the formatted date string
            return `${day}/${month}/${year}`;
        }
    }

    timeDifference1(start, end) {
        // Convert time strings to seconds
        
        const startParts = start.split(':').map(Number);
        const endParts = end.split(':').map(Number);
        const startInSeconds = startParts[0] * 3600 + startParts[1] * 60 + startParts[2];
        const endInSeconds = endParts[0] * 3600 + endParts[1] * 60 + endParts[2];

        console.log("endInSeconds====",endInSeconds,"startInSeconds=======",startInSeconds);

        // Calculate the difference in seconds
        const diffInSeconds = endInSeconds - startInSeconds;

        // Calculate hours, minutes, and seconds from the difference
        const hours = Math.floor(diffInSeconds / 3600);
        const minutes = Math.floor((diffInSeconds % 3600) / 60);
        const seconds = diffInSeconds % 60;

        const formattedTime = [
            String(hours).padStart(2, '0'),
            String(minutes).padStart(2, '0'),
            String(seconds).padStart(2, '0')
        ].join(':');

        return formattedTime;
    }
 timeDifference(start, end) {
     console.log("endTime====",end,"startTime=======",start);
    
    // Ensure the inputs are numbers
    const startTime = Number(start);
    const endTime = Number(end);
   

    if (isNaN(startTime) || isNaN(endTime)) {
    return "---";
  }

    // Calculate difference in milliseconds
    const diffInMs = endTime - startTime;

    if (diffInMs < 0) {
        return "00:00:00"; // or handle negative values as needed
    }

    // Convert milliseconds to seconds
    const diffInSeconds = Math.floor(diffInMs / 1000);

    // Calculate hours, minutes, and seconds
    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    // Format the output
    return [
        String(hours).padStart(2, '0'),
        String(minutes).padStart(2, '0'),
        String(seconds).padStart(2, '0')
    ].join(':');
}
    convertSecondsToMinutes(seconds) {
        seconds = parseInt(seconds); // Ensure input is an integer
        if (seconds < 60) {
            return `${seconds} seconds`;
        } else if (seconds < 3600) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${minutes} minutes ${remainingSeconds} seconds`;
        } else {
            const hours = Math.floor(seconds / 3600);
            const remainingSeconds = seconds % 3600;
            const minutes = Math.floor(remainingSeconds / 60);
            const finalSeconds = remainingSeconds % 60;
            return `${hours} hours ${minutes} minutes ${finalSeconds} seconds`;
        }
    }

    markFormGroupTouched(formGroup: FormGroup) {
        (<any>Object).values(formGroup.controls).forEach(control => {
          control.markAsTouched();
          if (control.controls) {
            this.markFormGroupTouched(control);
          }
        });
      }
      
      sortDatesWithTime(data,key) {
    return new Promise((res,rej)=>{
        try {
     const now = new Date();
    const today = new Date(now.setHours(0, 0, 0, 0));
    let sortedData = data.sort((a, b) => {

        const adatetime=new Date(a.tripDate).setHours(a.shiftTime,0,0,0)
       const bdatetime = new Date(b.tripDate).setHours(b.shiftTime,0,0,0) 
    
       const dateA = new Date(adatetime);
      const dateB = new Date(bdatetime);

      const isTodayA = dateA.toDateString() === today.toDateString();
      const isTodayB = dateB.toDateString() === today.toDateString();

      if (isTodayA && !isTodayB) return -1;
      if (isTodayB && !isTodayA) return 1;

      return dateA.getTime() - dateB.getTime();
    });
          
        res(sortedData);
        } catch (err) { 
          console.log(err);
          rej([])
        }
      })
  }
}
